module.exports = __webpack_public_path__ + "img/title_txt_day3.03337df3.png";